import { ShiftReportConfigPage } from "./ShiftReportConfigPage";

const ShiftReportConfig = () => <ShiftReportConfigPage />;

export default ShiftReportConfig;
